export const isCompactShellRoutePath = (pathname) => {
  const normalizedPath = String(pathname || '').replace(/\/$/, '') || '/';
  const compactPrefixes = [
    '/dashboard',
    '/operations',
    '/vehicles',
    '/drivers',
    '/maintenance',
    '/fleet-expenses',
    '/fuel-cards',
    '/fines',
    '/workshops',
  ];
  return compactPrefixes.some(
    (prefix) => normalizedPath === prefix || normalizedPath.startsWith(`${prefix}/`)
  );
};
